import { atom } from "recoil";

export const indexPathState = atom({
  key: "indexPathState",
  default: 0,
});
